import Vue from "vue";
import App from "./app/app.vue";
import router from "./app/app-routes";
import store from "./app/app-state";
import i18n from "./plugins/i18n";
import "./plugins";
import "./main.scss";
//import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import moment from "moment";
import _ from "lodash";
import AdvancedDataTable from "./plugins/Extensions/AdvancedDataTable";
import VueEasyLightbox from "vue-easy-lightbox";

Vue.use(VueEasyLightbox);

Vue.config.productionTip = false;

Vue.prototype.moment = moment;

Vue.component("advanced-data-table", AdvancedDataTable);

Vue.prototype._ = _;

Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(String(value))
      .utcOffset(240)
      .format("DD.MM.YYYY HH:mm");
  }
});

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY");
  }
});

Vue.filter("addToken", function(value) {
  if (value) {
    return value + "?token=" + localStorage.getItem("laravel-vue-spa");
  }
});

var filter = function(text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter("truncate", filter);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
